import Socket, { ConnectedUser } from '../connection/socket';
import store from '../stores/main';
import Invitations from './invitations';
import Users from './users';
import Media from './media';
import Broadcast from './broadcasting';
import Video from './video';
import Chat from './chat';
import Settings from './settings';
import HostSync from './host-sync';
import Errors from './errors';
import Session from './session';
import Shots from './shots';
import Sync from './sync';
import { log } from '../utils/logger';
import { setShotReducerSocket } from '../stores/reducers/shots';
import Teleprompters from './teleprompters';
import Graphics from './graphics';
import { Action, AsyncAction } from '../stores/types/types';
import GenerateContent from './generate-content';

interface ActionCallback {
	[key: string]: () => void;
}

const actionListeners: ActionCallback = {};

export function getState() {
	return store.getState();
}

export default function SocketListeners(socket: Socket) {
	const {
		SessionReducer: {
			host,
			meeting,
			user,
		},
		DebugReducer: {
			debugDisconnectProducer,
		},
	} = getState();

	Invitations(socket);
	Users(socket);
	Media(socket);
	Broadcast(socket);
	Video(socket);
	Chat(socket);
	Session(socket);
	Settings(socket);
	Shots(socket);
	Errors(socket);
	Sync(socket);
	setShotReducerSocket(socket);
	Teleprompters(socket);
	Graphics(socket);
	GenerateContent(socket);

	if (user?.gr_user) {
		socket.addNewChannel(`gr_user-${user?.gr_user}`);
	}

	if (host) {
		HostSync(socket);

		setInterval(() => {
			const {
				VideoReducer: { isLive },
				SessionReducer: { connectedUsers },
			} = getState();

			const ids = connectedUsers.map((connUser: ConnectedUser) => connUser.gr_user);

			if (window.location.search.includes('debug') && !debugDisconnectProducer) {
				console.log(`firing producer_connected ${meeting?.meeting}`);
			}

			// If debug disconnect producer is on, disable logs to act as if the producer is not connected
			if (!debugDisconnectProducer) {
				log({ producer_connected: meeting?.meeting });
			}

			if (isLive) {
				log({ is_live: meeting?.meeting });
			}

			if (!debugDisconnectProducer) {
				log({ connected_users: ids });
			}
		}, 1000 * 20);

		log({ producer_connected: meeting?.meeting });
	} else {
		setInterval(() => {
			const { SessionReducer: { connectedUsers } } = getState();
			const ids = connectedUsers.map((connUser: ConnectedUser) => connUser.gr_user);
			log({ connected_users: ids });
		}, 1000 * 20);
	}
}

store.subscribe(() => {
	actionListeners[(getState().lastAction.type)]?.();
});

export function Subscribe(action: string, callback: () => void) {
	actionListeners[action] = callback;
}

export function socketListenerDispatch(action: Action | AsyncAction) {
	return store.dispatch({ ...action, socket: true });
}
